// ACTIONS
import * as actionTypes from '../../constants/index'

export const setFormats = (formats) => ({
  type: actionTypes.SET_FORMATS,
  payload: formats
})
